import React from "react";

// React Components:
import Select from 'react-select';

function ReactSelect({key,isMulti,options,value,handleChange}) {

    return(

        <Select
            // key={key}
            isMulti={isMulti}
            options={options}
            value={value} 
            onChange={handleChange}
            components={{ 
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null 
            }}>
        </Select>
    )


}

export default ReactSelect;